export default __webpack_public_path__ + "static/media/cup_categories_white.1b491fc8.svg";